<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Dane rejestrowanego podmiotu</h2>
			</div>

			<v-container class="text-xs-center mt-5">
				<v-layout align-center justify-center row>

					<v-flex sm1/>
					<v-flex xs12 sm6>
						<v-text-field
							browser-autocomplete="organization"
							data-vv-name="polishName"
							data-vv-as="Polska nazwa podmiotu"
							:error-messages="vErrors.collect('scope2.polishName')"
							label="Polska nazwa podmiotu *"
							aria-label="label for organization polish name"
							for="step-choose-organization-name-component-polish-name"
							id="step-choose-organization-name-component-polish-name"
							v-model="stepData.polishName"
							outline
							v-validate="'required'"
							required data-vv-scope="scope2"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
					<v-flex xs12 sm6>
						<v-text-field
							browser-autocomplete="organization"
							data-vv-name="englishName"
							data-vv-as="Angielska nazwa podmiotu"
							:error-messages="vErrors.collect('scope2.englishName')"
							label="Angielska nazwa podmiotu *"
							aria-label="label for organization english name"
							for="step-choose-organization-name-component-english-name"
							id="step-choose-organization-name-component-english-name"
							v-model="stepData.englishName"
							outline
							v-validate="'required'"
							data-vv-scope="scope2"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
				</v-layout>
			</v-container>

			<div class="text-xs-center mt-5">
				<h2>Osoba uprawniona do reprezentowania podmiotu</h2>
			</div>

			<v-container class="text-xs-center mt-4">
				<v-layout align-space-between justify-space-around>

					<v-flex xs12 sm6>
						<v-text-field
							browser-autocomplete="given-name"
							data-vv-name="representativeName"
							data-vv-as="Imię"
							:error-messages="vErrors.collect('scope2.representativeName')"
							label="Imię *"
							aria-label="label for representative person name"
							for="step-choose-organization-name-component-name"
							id="step-choose-organization-name-component-name"
							v-model="stepData.representativePerson.name"
							v-validate="'required'"
							data-vv-scope="scope2"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
					<v-flex xs12 sm6>
						<v-text-field
							browser-autocomplete="family-name"
							data-vv-name="representativeSurname"
							data-vv-as="Nazwisko"
							:error-messages="vErrors.collect('scope2.representativeSurname')"
							label="Nazwisko *"
							aria-label="label for representative person surname"
							for="step-choose-organization-name-component-surname"
							id="step-choose-organization-name-component-surname"
							v-model="stepData.representativePerson.surname"
							v-validate="'required'"
							data-vv-scope="scope2"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
					<v-flex xs12 sm6>
						<v-text-field
							browser-autocomplete="organization-title"
							data-vv-name="representativePosition"
							data-vv-as="Funkcja"
							:error-messages="vErrors.collect('scope2.representativePosition')"
							label="Funkcja *"
							aria-label="label for representative person position"
							for="step-choose-organization-name-component-position"
							id="step-choose-organization-name-component-position"
							v-model="stepData.representativePerson.position"
							v-validate="'required'"
							data-vv-scope="scope2"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
				</v-layout>
			</v-container>

			<div>
				<v-btn
					@click="handleOptionalSecondChosen"
					color="blue"
					class="mb-3">
					Druga osoba&nbsp;
					<v-icon v-if="optionalSecondChosen">indeterminate_check_box</v-icon>
					<v-icon v-else>person_add</v-icon>
				</v-btn>
			</div>

			<div>
				<v-expand-transition>
					<div v-if="optionalSecondChosen">
						<div class="text-xs-center mt-3">
							<h2>Druga osoba uprawniona do reprezentowania podmiotu</h2>
						</div>

						<v-container class="text-xs-center mt-4">
							<v-layout align-space-between justify-space-around>

								<v-flex xs12 sm6>
									<v-text-field
										browser-autocomplete="given-name"
										data-vv-name="secondRepresentativeName"
										data-vv-as="Imię"
										:error-messages="vErrors.collect('scope2.secondRepresentativeName')"
										label="Imię *"
										aria-label="label for second representative person name"
										for="step-choose-organization-name-component-name*"
										id="step-choose-organization-name-component-name*"
										v-model="stepData.secondRepresentativePerson.name"
										v-validate="'required'"
										data-vv-scope="scope2"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm6>
									<v-text-field
										browser-autocomplete="family-name"
										data-vv-name="secondRepresentativeSurname"
										data-vv-as="Nazwisko"
										:error-messages="vErrors.collect('scope2.secondRepresentativeSurname')"
										label="Nazwisko *"
										aria-label="label for second representative person surname"
										for="step-choose-organization-name-component-surname*"
										id="step-choose-organization-name-component-surname*"
										v-model="stepData.secondRepresentativePerson.surname"
										v-validate="'required'"
										data-vv-scope="scope2"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm6>
									<v-text-field
										browser-autocomplete="organization-title"
										data-vv-name="secondRepresentativePosition"
										data-vv-as="Funkcja"
										:error-messages="vErrors.collect('scope2.secondRepresentativePosition')"
										label="Funkcja *"
										aria-label="label for second representative person position"
										for="step-choose-organization-name-component-position*"
										id="step-choose-organization-name-component-position*"
										v-model="stepData.secondRepresentativePerson.position"
										v-validate="'required'"
										data-vv-scope="scope2"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
							</v-layout>
						</v-container>
					</div>
				</v-expand-transition>
			</div>
		</v-card>
		<v-btn
			color="blue"
			@click="$emit('step', 1)"
		>Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 3, 'scope2')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepChooseOrganizationName",
		inject: ["parentValidator"],

		methods: {

			handleOptionalSecondChosen() {
				this.optionalSecondChosen = !this.optionalSecondChosen;

				if (this.optionalSecondChosen === false) {
					this.stepData.secondRepresentativePerson.name = "";
					this.stepData.secondRepresentativePerson.surname = "";
					this.stepData.secondRepresentativePerson.position = "";
				}
			},
		},

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				optionalSecondChosen: false,
			};
		},
		props: {
			stepData: Object,
		},
	};
</script>

<style scoped>
	.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: #212121 !important;
	}

	.v-btn:not(.v-btn--disabled):not(.v-btn--floating):not(.v-btn--icon) .v-btn__content .v-icon {
		color: #fff !important;
	}
</style>
